const creationEvents = {
  color: 'success',
  events: [
    'created',
    'added',
    'issued',
    'requested',
    'registered',
    'merged',
    'linked',
    'allocated',
    'request',
  ],
};

const deletionEvents = {
  color: 'danger',
  events: [
    'removed',
    'destroyed',
    'deleted',
    'cancelled',
    'unlinked',
    'deallocated',
  ],
};

const changeEvents = {
  color: 'info',
  events: [
    'changed',
    'updated',
    'transferred',
    'confirmed',
    'completed',
    'refunded',
    'enabled',
    'disabled',
    'deactivated',
    'entered',
    'exited',
    'captured',
    'reset',
    'modified',
    'released',
    'throttled',
    'login_pw',
    'login_otp',
    'transfer',
    'preauth',
  ],
};

const timeEvents = {
  color: 'warning',
  events: ['expired', 'renewed', 'renewal', 'pending', 'overdue'],
};

const errorEvents = {
  color: 'primary',
  events: ['error', 'failed'],
};

export const getColorFromEvent = (event) => {
  const catagories = [
    creationEvents,
    deletionEvents,
    changeEvents,
    timeEvents,
    errorEvents,
  ];

  const catagory = catagories.find(
    (category) =>
      category.events.filter((evt) => event.includes(evt)).length > 0,
  );
  if (!catagory) {
    return '';
  }

  return catagory.color;
};

export const getIconFromModel = (model) => {
  switch (model) {
    case 'creditcard':
    case 'stripecard':
      return 'glyphicon-credit-card';
    case 'purchase':
    case 'purchaseorder':
      return 'glyphicon-usd';
    case 'subscription':
      return 'glyphicon-refresh';
    case 'userprofile':
      return 'glyphicon-user';
    case 'lease':
      return 'glyphicon-book';
    case 'credit':
      return 'glyphicon-piggy-bank';
    case 'authcode':
      return 'glyphicon-lock';
    case 'apikey':
      return 'glyphicon-flag';
    case 'billingcycle':
      return 'glyphicon-repeat';
    default:
      return 'glyphicon-cog';
  }
};

export const eventTypes = [
  'subscription_agent_changed',
  'att_subscription_created',
  'att_subscription_deleted',
  'cycle_allocated',
  'cycle_deallocated',
  'subscription_renewed',
  'forced_renewal_purchase',
  'autopay_renewal_purchase',
  'lease_created',
  'lease_transferred',
  'lease_deleted',
  'card_add_failed',
  'card_added',
  'order_cancelled',
  'charge_captured',
  'purchase_completed',
  'charge_preauth',
  'charge_released',
  'charge_refunded',
  'purchase_refunded',
  'purchase_merged',
  'purchase_linked',
  'purchase_unlinked',
  'purchase_cancelled',
  'credit_created',
  'credit_cancelled',
  'credit_destroyed',
  'order_confirmed',
  'charge_error',
  'blacklist_zone_entered',
  'blacklist_zone_exited',
  'login_otp_request',
  'login_device_request',
  'reset_pin_request',
  'reset_device_pw_request',
  'verify_email_request',
  'api_key_issued',
  'api_key_expired',
  'autopay_enabled',
  'autopay_disabled',
  'user_created',
  'user_updated',
  'user_deactivated',
  'card_removed',
  'changed_password',
  'reset_password_request',
  'reset_password',
  'insurance_enabled',
  'insurance_disabled',
  'plan_change_requested',
  'plan_changed',
  'activation_requested',
  'activation_pending',
  'subscription_error',
  'subscription_created',
  'activation_completed',
  'subscription_deleted',
  'subscription_expired',
  'subscription_suspended',
  'subscription_restored',
  'subscription_ip_updated',
  'subscription_transferred',
  'subscription_throttled',
  'port_response',
  'port_modified',
  'device_updated',
  'device_registered',
  'device_pw_reset',
  'port_out_requested',
  'port_out_None',
  'plan_change_error',
  'reset_pin',
  'login_pw',
];
